// ─── i18n strings ─────────────────────────────────────────────────────────────
// No i18n library is installed in this portal (plain React + Vite). Strings are
// inlined here and collected in one object so they can later be extracted into a
// locale file. DE is the primary language, matching the rest of the portal.

export const LABELS = {
  page: {
    /** Page heading. */
    title: 'Session-Volumen',
    /** Page sub-heading. */
    subtitle: 'Voice-, Chat- und Gesamt-Sessions je Monat',
  },
  tabs: {
    voice: 'Sprache',
    chat: 'Chat',
    combined: 'Gesamt',
  },
  metrics: {
    /** Total sessions in the selected month, per channel. */
    total: {
      voice: 'Anrufe im Monat',
      chat: 'Chat-Sessions im Monat',
      combined: 'Sessions im Monat (Voice + Chat)',
    },
    /** Sessions per day, per channel. */
    perDay: {
      voice: 'Anrufe je Tag',
      chat: 'Chat-Sessions je Tag',
      combined: 'Sessions je Tag',
    },
    /** Peak concurrent sessions per day, per channel. */
    maxParallel: {
      voice: 'Max. parallele Anrufe je Tag',
      chat: 'Max. parallele Chat-Sessions je Tag',
      combined: 'Max. parallele Sessions je Tag',
    },
  },
  states: {
    error: 'Fehler beim Laden der Anrufvolumen-Daten.',
    empty: 'Keine Daten verfügbar',
  },
  /** Month names for the month selector, index 0 = Januar. */
  months: [
    'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
    'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember',
  ],
} as const;
